import React, { useState } from "react";
//import { DropdownButton, Dropdown } from 'react-bootstrap';
import { FaSortUp, FaSortDown } from 'react-icons/fa'; //  FaTrashAlt, FaSave, FaExternalLinkAlt, FaFileUpload
import { IconContext } from "react-icons";
import { getEntityFullName } from "../components/tools";
import { CardPreviewMedia } from "../client-details/CardPreviewMedia";
import { CardPreviewQuiz } from "../client-details/CardPreviewQuiz";

export const LessonExperiencesTable = ({ activeLanguage, lesson, changeExperienceIndex, deleteExperience, editableContent, activeLineEnabled = false, updateLesson, setReceivedError }) => {

    const [activeLineExperience, setActiveLineExperience] = useState(null)
    const [currentContent, setCurrentContent] = useState(null)

    let updateExperience = (experience) => {
        const experiences = lesson.experiences.map(e => {
            if (e.id === experience.id)
                return experience;
            else
                return e;
        })

        updateLesson({ ...lesson, experiences });
    };

    const aciveLineRender = (experience) => {
        let currentContentRender = null;

        switch (currentContent) {

            case 'media': currentContentRender = CardPreviewMedia(experience); break;
            case 'quiz': currentContentRender = <CardPreviewQuiz
                lessonId={lesson.id}
                experience={experience}
                updateExperience={updateExperience}
                setReceivedError={setReceivedError}
            />; break;
            default: currentContentRender = null
        }

        if (currentContentRender)
            return (<tr key={-1}><td colSpan={4}>{currentContentRender}</td></tr>)
        else {
            setActiveLineExperience(null);
            return null;
        }
    }


    return (
        <table className="Table">
            <thead>
                <tr className="TableBlock">
                    {editableContent ? [
                        <th key="sort" className="TableFirstLineBlock">Sort</th>,
                        <th key="name" className="TableFirstLineBlock">Name</th>,
                        <th key="content" className="TableFirstLineBlock">Content</th>,
                        <th key="action" className="TableFirstLineBlock">Action</th>
                    ] :
                        [
                            <th key="name" className="TableFirstLineBlock">Name</th>,
                            <th key="content" className="TableFirstLineBlock">Content</th>
                        ]}

                </tr>
            </thead>

            <tbody>
                {lesson.experiences?.length ? (
                    lesson.experiences
                        .sort((a, b) => a.index - b.index)
                        .map((experience, index, array) => {
                            let commonLineRender = (
                                <tr
                                    key={experience.linkId}
                                >
                                    {editableContent && (
                                        <td className="TableSecondLineBlock CenterLessons">
                                            <div className="d-inline-flex flex-column">
                                                <IconContext.Provider value={{ color: "white" }}>

                                                    {array[index - 1] && (
                                                        <FaSortUp
                                                            className="d-flex flex-column"
                                                            onClick={() => changeExperienceIndex(experience.linkId, array[index - 1].linkId)}
                                                        />
                                                    )}

                                                    {array[index + 1] && (
                                                        <FaSortDown
                                                            className="d-flex flex-column "
                                                            onClick={() => changeExperienceIndex(array[index + 1].linkId, experience.linkId)}
                                                        />
                                                    )}
                                                </IconContext.Provider>
                                            </div>
                                        </td>
                                    )}

                                    <td className="TableSecondLineBlock TableSecondLineText">{getEntityFullName(experience, activeLanguage)}</td>

                                    <td className="TableSecondLineBlock TableSecondLineText">
                                        <span className="d-flex">
                                            <div className="text-center" onClick={() => {
                                                if (activeLineEnabled) {
                                                    setActiveLineExperience(experience);
                                                    setCurrentContent('media');
                                                }
                                            }}>
                                                <img src="/img/360.png" className="TableContentStatImg"
                                                    alt={"" + experience.video_360?.map(v => v.name).join(', ')} />
                                                <small className="TableContentStatText d-block pt-1">{experience.video_360?.length}</small>
                                            </div>

                                            <div className="text-center" onClick={() => {
                                                if (activeLineEnabled) {
                                                    setActiveLineExperience(experience);
                                                    setCurrentContent('media');
                                                }
                                            }}>
                                                <img src="/img/FlatVideo.png" className="TableContentStatImg" alt={"" + experience.video_flat?.map(v => v.name).join(', ')} /><br />
                                                <small className="TableContentStatText d-block pt-1">{"" + experience.video_flat?.length}</small>
                                            </div>
                                            <div className="text-center" onClick={() => {
                                                if (activeLineEnabled) {
                                                    setActiveLineExperience(experience);
                                                    setCurrentContent('quiz');
                                                }
                                            }}>
                                                <img src="/img/Quiz.png" className="TableContentStatImg" alt={"" + experience.quiz?.map(v => v.name).join(', ')} /><br /><small className="TableContentStatText d-block pt-1">{experience.quiz?.length}</small>
                                            </div>
                                        </span>
                                    </td>

                                    {editableContent && (
                                        <td className="TableSecondLineBlock CenterLessons">
                                            <img
                                                src="/img/TrashB.png"
                                                alt="" onClick={() => {
                                                    if (window.confirm("Remove this item from the current lesson?")) {
                                                        deleteExperience(lesson.id, experience);
                                                    }
                                                }}
                                                className="text-danger mx-1 TableSecondLineImg"
                                            />
                                        </td>
                                    )}
                                </tr>
                            );

                            if (activeLineExperience?.id === experience.id && activeLineEnabled) {
                                return [commonLineRender, aciveLineRender(experience)]
                            } else {
                                return commonLineRender
                            }
                        })
                ) : (
                    <tr className="NoElementsText"><td colSpan={4} className="text-center">No Content</td></tr>
                )}
            </tbody>
        </table >
    )
};
